import { formatCurrency, formatNumber, useTranslation } from '@hbs-us/ui';

/**
 * Locale-aware formatters for the Jobs cluster (Shared 8 — clone of `_money/useMoneyFormatters`
 * with an added `hours` helper for the Labor tab). These wrap the `@hbs-us/ui` Intl helpers with
 * the ACTIVE i18n locale so figures render with locale separators (never an en-US-locked
 * `toLocaleString`). Hours render with up to 2 fraction digits.
 */
export function useJobFormatters() {
  const { i18n } = useTranslation();
  const locale = i18n.language || 'en';

  return {
    formatCurrency: (value: number): string =>
      formatCurrency(value || 0, locale, 'USD', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    hours: (value: number): string =>
      formatNumber(value || 0, locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
  };
}
